/**
 * Labstep
 *
 * @module grid/SmartTableProtocolValue/coldefs/entity/metadata
 * @desc Column Definition for entity metadata
 */

import { getMetadataDateColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/date';
import { getMetadataDatetimeColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/datetime';
import { getMetadataDefaultColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/default';
import { getMetadataEntityRelationColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/entity-relation';
import { getMetadataFileColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/file';
import { getMetadataNumericColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/numeric';
import { getMetadataOptionsColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/options';
import { getMetadataSequenceColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/sequence';
import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/types';
import type { Experiment } from 'labstep-web/models/experiment.model';
import { MetadataType } from 'labstep-web/models/metadata/types';
import type { Protocol } from 'labstep-web/models/protocol.model';

export const getMetadataColDef = (
  experimentOrProtocol: Experiment | Protocol,
  parentEntityClass: string,
  metadataType: MetadataType,
  metadataLabel: string,
  protocolValueName?: string,
): SmartTableColDef => {
  switch (metadataType) {
    case MetadataType.numeric:
      return getMetadataNumericColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.date:
      return getMetadataDateColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.datetime:
      return getMetadataDatetimeColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.file:
      return getMetadataFileColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.options:
      return getMetadataOptionsColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.sequence:
      return getMetadataSequenceColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case MetadataType.entity_relation:
      return getMetadataEntityRelationColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    default:
      return getMetadataDefaultColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
  }
};
